module.exports = __webpack_public_path__ + "img/Pack_check_up_annuel.abe872c2.jpeg";